import React, { useEffect, useState } from 'react';
import styles from '../styles/Collections.module.css';
import { getData, postData, putData, postFormData, deleteData } from '../ServerRequest.js';
const Collections = () => {
  const [collections, setCollections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try{
        const collectionsRes = await getData(`/api/product/collections/?company_id=1`);
        if (collectionsRes.data?.collections) {
          setCollections(collectionsRes.data.collections);
        }
        // Fetch categories for dropdown
        const categoriesRes = await getData(`/api/product/categories/?company_id=1`);
        if (categoriesRes.data?.categories) {
          setCategories(categoriesRes.data.categories);
        }
      }
      catch (err) {
        console.error('API Error:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingCollection, setEditingCollection] = useState(null);
  const [formData, setFormData] = useState({
  name: '',
  description: '',
  status: 'Active',
  category_id: ''
  });

  const filteredCollections = collections?.filter(collection =>{
    console.log("filter",collection.collection);
    return (collection?.collection?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.category_id) {
      alert('Collection name and category are required');
      return;
    }
    // Prepare payload for API
    const payload = {
      collection: formData.name,
      category_id: Number(formData.category_id),
      status: formData.status === 'Active' ? true : false
    };
    postData('/api/product/collections/?company_id=1', payload)
      .then(res => {
        if (res && res.data && res.data.collection) {
          setCollections(prev => [...prev, res.data.collection]);
          alert(res.data.message || 'Collection added!');
        } else {
          alert((res.data && res.data.message) || 'Failed to add collection');
        }
        setFormData({ name: '', description: '', status: 'Active', category_id: '' });
        setShowForm(false);
      })
      .catch(() => {
        alert('Failed to add collection');
      });
  };

  const handleEdit = (collection) => {
    setEditingCollection(collection);
    setFormData({
      name: collection.name,
      description: collection.description,
      status: collection.status
    });
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this collection?')) {
      deleteData(`/api/product/collections/${id}/?company_id=1`)
        .then(res => {
          if (res.code === 200 && res.data && res.data.message) {
            setCollections(collections.filter(col => col.id !== id));
            alert(res.data.message);
          } else {
            alert((res.data && res.data.message) || 'Failed to delete collection');
          }
        })
        .catch(() => {
          alert('Failed to delete collection');
        });
    }
  };

  const toggleStatus = (id) => {
    setCollections(collections.map(col =>
      col.id === id
        ? { ...col, status: col.status === 'Active' ? 'Inactive' : 'Active' }
        : col
    ));
  };

  return (
    <div className={styles.collectionsContainer}>
      {showForm ? (
        <div className={styles.formContainer}>
          <h3 className={styles.formTitle}>
            {editingCollection ? 'Edit Collection' : 'Add New Collection'}
          </h3>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGrid}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>
                  Collection Name *
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className={styles.formInput}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Category *</label>
                <select
                  value={formData.category_id}
                  onChange={e => setFormData({ ...formData, category_id: e.target.value })}
                  required
                  className={styles.formInput}
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.category || cat.name}</option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>
                  Status
                </label>
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  className={styles.formInput}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            </div>
            <div className={styles.formGroup} style={{ marginBottom: '1.5rem' }}>
              <label className={styles.formLabel}>
                Image URL *
              </label>
              <input
                type="file"
                onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                className={styles.formInput}
              />
            </div>
            <div className={styles.formActions}>
              <button
                type="submit"
                className={styles.submitBtn}
              >
                {editingCollection ? 'Update Collection' : 'Add Collection'}
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowForm(false);
                  setEditingCollection(null);
                  setFormData({ name: '', description: '', status: 'Active' });
                }}
                className={styles.cancelBtn}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : (
        <>
          <div className={styles.headerRow}>
            <h2>Collections({filteredCollections.length})</h2>
            <button 
              className={styles.addBtn}
              onClick={() => {
                setShowForm(true);
                setEditingCollection(null);
                setFormData({ name: '', description: '', status: 'Active' });
              }}
            >
              Add Collection
            </button>
          </div>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search collections..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>
          <div className={styles.grid}>
            {loading ? (
              <div className={styles.spinnerWrapper}>
                <div className={styles.spinner}></div>
                <div className={styles.spinnerText}>Loading products...</div>
              </div>
            ) : filteredCollections?.map(collection => (
              <div key={collection.id} className={styles.card}>
                <div className={styles.cardContent}>
                  {/* Image section */}
                  <div className={styles.imageWrapper} style={{ marginBottom: '12px', textAlign: 'center' }}>
                    <img
                      src={collection.image || 'https://via.placeholder.com/120x80?text=No+Image'}
                      alt={collection.collection}
                      style={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 8, background: '#f3f3f3' }}
                    />
                  </div>
                  <h3 className={styles.collectionName}>{collection.collection}</h3>
                  <p>{collection.category.name}</p>
                  <div className={styles.statusContainer}>
                    <span className={`${styles.statusBadge} ${collection.status ? styles.statusActive : styles.statusInactive}`}>
                      {collection.status}
                    </span>
                  </div>
                  <div className={styles.cardActions}>
                    <button
                      onClick={() => handleEdit(collection)}
                      className={styles.editBtn}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => toggleStatus(collection.id)}
                      className={`${styles.toggleBtn} ${collection.status ? styles.toggleBtnActive : styles.toggleBtnInactive}`}
                    >
                      {collection.status ? 'Deactivate' : 'Activate'}
                    </button>
                    <button
                      onClick={() => handleDelete(collection.id)}
                      className={styles.deleteBtn}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Collections;